import { render, staticRenderFns } from "./logs-history.vue?vue&type=template&id=1bccba3b"
import script from "./logs-history.vue?vue&type=script&lang=js"
export * from "./logs-history.vue?vue&type=script&lang=js"
import style0 from "./logs-history.vue?vue&type=style&index=0&id=1bccba3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports